import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=b936a952&"
import script from "./ContactView.vue?vue&type=script&lang=ts&"
export * from "./ContactView.vue?vue&type=script&lang=ts&"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=b936a952&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports